<div class="totalContainer links_content">
  <div class="banner-full-image">
    <img
      src="../../../../assets/images/my-links/onpassive-tab/one-space.png"
      alt="one-space"
      class="w-100"
    />
   
  </div>
  <div
    class="rocket aos-init aos-animate"
    data-aos="fade-up"
    data-aos-delay="500"
  >
    <div class="rocket-img">
      <img
        src="../../../../assets/images/my-links/onpassive-tab/Rocket-Ship.png"
        alt="Rocket-ship"
        
      />
    </div>
  </div>
  <div class="site-header w-100 mb-1 mb-md-5">
    <div class="logo text-center pt-5 pb-0 py-md-4">
      <a href="javascript:void(0)" class="mr-md-4 px-4 px-md-0 d-inline-block">
        <img
          src="../../../../assets/images/my-links/onpassive-tab/Onpassive-Logo 16.png"
          alt="Onpassive-Logo"
          class="img-fluid"
        />
      </a>
    </div>
  </div>
  <section class="banner text-white pt-4 pt-md-0 pb-md-5">
    <div class="container">
      <div
        class="
          row
          justify-content-between
          align-content-stretch align-items-stretch
        "
      >
        <div class="col-md-6 col-lg-5">
          <div
            class="
              banner-content
              d-flex
              flex-column
              align-content-stretch
              h-100
            "
          >
            <h1
              class="font-weight-bold nunito aos-init aos-animate"
              data-aos="fade-right"
            >
              New Revolutionized Internet Marketing Solution
            </h1>
            <h3 class="invite_text">You are invited by: {{ userName }}</h3>
            <p class="ml1 desktop-btn" style="opacity: 1">
              <span class="text-wrapper text-line">
                <span
                  class="line line1"
                  style="opacity: 1; transform: scaleX(1)"
                ></span>
                <span class="letters"
                  ><span
                    class="letter"
                    style="opacity: 1; transform: scale(1) translateZ(0px)"
                    >W</span
                  ><span
                    class="letter"
                    style="opacity: 1; transform: scale(1) translateZ(0px)"
                    >e</span
                  ><span
                    class="letter"
                    style="opacity: 1; transform: scale(1) translateZ(0px)"
                    >l</span
                  ><span
                    class="letter"
                    style="opacity: 1; transform: scale(1) translateZ(0px)"
                    >c</span
                  ><span
                    class="letter"
                    style="opacity: 1; transform: scale(1) translateZ(0px)"
                    >o</span
                  ><span
                    class="letter"
                    style="opacity: 1; transform: scale(1) translateZ(0px)"
                    >m</span
                  ><span
                    class="letter"
                    style="opacity: 1; transform: scale(1) translateZ(0px)"
                    >e</span
                  >
                  <span
                    class="letter"
                    style="opacity: 1; transform: scale(1) translateZ(0px)"
                    >T</span
                  ><span
                    class="letter"
                    style="opacity: 1; transform: scale(1) translateZ(0px)"
                    >o</span
                  >
                  <span
                    class="letter"
                    style="opacity: 1; transform: scale(1) translateZ(0px)"
                    >T</span
                  ><span
                    class="letter"
                    style="opacity: 1; transform: scale(1) translateZ(0px)"
                    >h</span
                  ><span
                    class="letter"
                    style="opacity: 1; transform: scale(1) translateZ(0px)"
                    >e</span
                  >
                  <span
                    class="letter"
                    style="opacity: 1; transform: scale(1) translateZ(0px)"
                    >F</span
                  ><span
                    class="letter"
                    style="opacity: 1; transform: scale(1) translateZ(0px)"
                    >u</span
                  ><span
                    class="letter"
                    style="opacity: 1; transform: scale(1) translateZ(0px)"
                    >t</span
                  ><span
                    class="letter"
                    style="opacity: 1; transform: scale(1) translateZ(0px)"
                    >u</span
                  ><span
                    class="letter"
                    style="opacity: 1; transform: scale(1) translateZ(0px)"
                    >r</span
                  ><span
                    class="letter"
                    style="opacity: 1; transform: scale(1) translateZ(0px)"
                    >e</span
                  >
                  !!!</span
                >
                <span
                  class="line line2"
                  style="opacity: 1; transform: scaleX(1)"
                ></span>
              </span>
            </p>
          </div>
        </div>
        <div class="col-md-6 col-lg-7">
          <div class="mid_video mt-4 mt-md-0">
            <video
              id="my-video"
              class="video-js w-100"
              controls
              preload="auto"
              poster="{{
                myLinksS3URL
              }}frontend/greetingsgofound3/images/greeting2.png"
              data-setup="{}"
            >
              <source
                src="{{
                  myLinksS3URL
                }}videos/Onpassive_launching_page_video2.mp4"
                type="video/mp4"
              />
            </video>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="lunching text-white mt-md-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-5 text-center mt-5 mt-md-0 lunching-text order-lg-2">
          <h2 class="font-weight-bold">LAUNCHING SOON!</h2>
          <a
            href="/registration/user?reg={{ userId }}"
            name="regform"
            target="_blank"
            rel="noopener"
            class="btn btn-primary btn-lg rounded-0 nunito"
          >
            <span> BECOME A FOUNDER NOW</span></a
          >
          <div class="more-text text-left mt-5">
            <p class="mb-0">
              ONPASSIVE! World's most Powerful and lucrative marketing
              automation! Equipped with most attractive tools, it is a source of
              never-ending wealth. With its Artificial Intelligence, it
              guarantees visitors. In this little window of time, 576805+
              dreamers have joined worldwide. As the supreme choice, ONPASSIVE
              is really the definition of materialising vision.
            </p>
          </div>
        </div>
        <div class="col-lg-6 large-screen mr-auto order-lg-1">
          <h2>Top marketing automation all done for you!</h2>
          <ul class="p-0 m-0">
            <li>Honest Solution</li>
            <li>Breakthrough Tools</li>
            <li>Guaranteed Visitors</li>
            <li>100% Hands Free</li>
            <li>Breakthrough Income Opportunity</li>
            <li>Artificial Intelligence At Its Best</li>
            <li>576805+ Worldwide Leaders Joined Already</li>
          </ul>
        </div>
      </div>
    </div>
  </section>
  <footer class="site-footer mt-5 mb-4">
    <div class="container">
      <div class="row">
        <div class="col-12 text-center">
          <a href="javascript:void(0)">
            <img
              src="../../../../assets/images/my-links/onpassive-tab/footer-logo.png"
              alt="footer-logo"
              class="footer-logo img-fluid"
            />
            <!-- <img src="	{{ myLinksS3URL }}images/footer-logo.png"
              class="footer-logo img-fluid"> -->
          </a>
          <marquee>
            <h6 class="text-white">
              Only Qualified Founders Accepted in Prelaunch By Invitation Only
            </h6>
          </marquee>
          <p class="mb-0 text-white">All Rights Reserved ONPASSIVE 2018-2028</p>
        </div>
      </div>
    </div>
  </footer>
</div>
